import { showSuccess } from '@calendly/alert';
import { useOnValueChange } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Popup, Header, Title, Body, Footer } from '@calendly/ui/components/popup';
import { zIndexModal } from '@calendly/ui/z-index';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useGetUserQuery } from 'common';
import { useUnblockInviteeMutation } from 'shared/api/meetings';
const bodyTextCss = "b1yzpm0o";
const BodyText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(bodyTextCss, props.className)} />;
});
export const UnblockModal = ({
  event,
  invitee,
  onClose
}) => {
  const dispatch = useDispatch();
  const {
    data: currentUser
  } = useGetUserQuery();
  const [unblockInvitee, {
    isLoading,
    isSuccess,
    isError
  }] = useUnblockInviteeMutation();
  useOnValueChange(isSuccess, () => {
    if (isSuccess) {
      dispatch(showSuccess(I18n.t('publisher.block_invitee.unblock_modal.success')));
      onClose();
    }
  });
  useOnValueChange(isError, () => {
    if (isError) {
      onClose();
    }
  });
  const onConfirm = () => {
    unblockInvitee({
      hostId: currentUser.id,
      blockUuid: invitee.blockUuid,
      inviteeUuid: invitee.uuid,
      eventId: event.id,
      location: 'meetings_page'
    });
  };
  return <Popup onClose={onClose} zIndex={zIndexModal}>
      <Header>
        <Title>
          {I18n.t('publisher.block_invitee.unblock_modal.title', {
          name: invitee.name
        })}
        </Title>
      </Header>
      <Body>
        <BodyText>
          {I18n.t('publisher.block_invitee.unblock_modal.message')}
        </BodyText>
        <BodyText>
          {I18n.t('publisher.block_invitee.unblock_modal.subtext')}
        </BodyText>
      </Body>
      <Footer>
        <Button disabled={isLoading} decoration="secondary-outline" onClick={onClose}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button loading={isLoading} disabled={isLoading} decoration="primary" onClick={onConfirm}>
          {I18n.t('publisher.block_invitee.action.unblock')}
        </Button>
      </Footer>
    </Popup>;
};

require("./unblock_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./unblock_modal.js");